module.exports = __webpack_public_path__ + "static/media/send-backward.d0a4163e.svg";